export const neverBlockSender = "q5mIYc";
export default {neverBlockSender};